import React from 'react'
import styled from 'styled-components'
import { RouteButtonGroupType } from './RouteButtonGroupType'

const RouteButtonGroup: React.FC<{
	buttons: RouteButtonGroupType[]
	currentKey: string | null
}> = ({ buttons, currentKey }) => {
	return (
		<SegmentedControl>
			{buttons.map((button) => {
				const isActive = currentKey === button.key
				return (
					<Segment key={button.key} href={button.url} $active={isActive}>
						{button.label}
					</Segment>
				)
			})}
		</SegmentedControl>
	)
}

const SegmentedControl = styled.div`
	display: flex;
	gap: 4px;
	padding: 4px;
	border-radius: 16px;
	background-color: var(--search-field-bg-color);
	width: 100%;
`

const Segment = styled.a<{ $active: boolean }>`
	flex: 1;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 10px 16px;
	border-radius: 12px;
	font-size: 15px;
	font-weight: ${({ $active }) => ($active ? '600' : '500')};
	text-decoration: none;
	white-space: nowrap;
	transition: background-color 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;
	cursor: pointer;

	color: ${({ $active }) => ($active ? 'white' : 'var(--sub-text-color)')};
	background-color: ${({ $active }) => ($active ? 'var(--primary-color)' : 'transparent')};
	box-shadow: ${({ $active }) => ($active ? '0 1px 3px rgba(0, 0, 0, 0.08)' : 'none')};

	&:hover {
		color: var(--text-color);
		${({ $active }) => !$active && 'background-color: var(--hover-bg-color);'}
	}
`

export default RouteButtonGroup
